import { formatFileSize, MAX_EVIDENCE_FILES } from './InsuranceLicenseUtils';

type Props = {
	files: File[];
	error?: string;
	showError?: boolean;
	disabled?: boolean;
	onAddFiles: (files: FileList | null) => void;
	onRemoveFile: (index: number) => void;
	inputId: string;
};

export default function EvidenceFilesField(props: Props) {
	const { files, error, showError = true, disabled = false, onAddFiles, onRemoveFile, inputId } = props;

	return (
		<div className="insurance-license-evidence-field">
			<label htmlFor={inputId}>Evidence files (images or PDFs)</label>
			<input
				id={inputId}
				type="file"
				className="form-control"
				accept="image/*,.pdf,application/pdf"
				multiple
				disabled={disabled}
				onChange={(event) => {
					onAddFiles(event.target.files);
					event.target.value = '';
				}}
				aria-invalid={Boolean(showError && error)}
			/>
			<div className="insurance-license-evidence-help">
				Upload at least one file. Up to {MAX_EVIDENCE_FILES} files, 10MB each.
			</div>

			{files.length > 0 ? (
				<div className="insurance-license-evidence-list">
					{files.map((file, index) => (
						<div className="insurance-license-evidence-item" key={`${file.name}-${index}`}>
							<div className="insurance-license-evidence-meta">
								<span className="insurance-license-evidence-name">{file.name}</span>
								<span className="insurance-license-evidence-size">{formatFileSize(file.size)}</span>
							</div>
							<button
								type="button"
								className="insurance-license-action-link"
								disabled={disabled}
								onClick={() => onRemoveFile(index)}
							>
								Remove
							</button>
						</div>
					))}
				</div>
			) : null}

			{showError && error ? <div className="insurance-license-field-error">{error}</div> : null}
		</div>
	);
}
